import React from "react";

const Ito = () => {
  return (
    <section className="bg-black text-white py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col-reverse lg:flex-row gap-12 lg:gap-16 items-center">
          {/* Left Column - Video */}
          <div className="relative w-full lg:w-1/2">
            <div className="relative overflow-hidden rounded-2xl">
              <div className="absolute inset-0 blur-xl -z-10"></div>
              <video
                className="w-full h-auto relative z-10 rounded-2xl"
                src="/images/Itovideo.mp4"
                autoPlay
                loop
                muted
                playsInline
              />
            </div>
          </div>

          {/* Right Column - Content */}
          <div className="space-y-4 w-full lg:w-1/2 text-center lg:text-left">
            {/* Live Trading Badge */}
            <span className="inline-flex bg-transparent border border-[#A855F7] text-[#A855F7] px-5 py-2 rounded-md text-xs sm:text-sm md:text-base">
              Trading
            </span>

            {/* Main Heading */}
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold bg-gradient-to-r from-[#ECEFF0] to-[#E5C0FF] bg-clip-text text-transparent leading-snug sm:leading-tight">
              YOUR EARLY ADVANTAGE STARTS HERE
            </h2>

            {/* Sub Heading */}
            <p className="text-base sm:text-lg md:text-xl font-semibold text-[#E5C0FF]">
              Lock in Your Presale Price Before It's Gone
            </p>

            {/* 1st Presale Box */}
            <div className="bg-[#1C1428] py-5 px-4 rounded-lg">
              <div className="flex flex-col sm:flex-row justify-between items-center gap-2">
                <h3 className="text-xl sm:text-2xl font-bold bg-gradient-to-r from-[#ECEFF0] to-[#E5C0FF] bg-clip-text text-transparent">
                  1st Presale Price
                </h3>
                <h3 className="text-xl sm:text-2xl font-bold bg-gradient-to-r from-[#ECEFF0] to-[#E5C0FF] bg-clip-text text-transparent">
                  $0.0005 per coin
                </h3>
              </div>
            </div>

            <p className="text-sm sm:text-base text-gray-300 leading-relaxed">
              (Only 2 billion coins available at this exclusive price)
            </p>

            {/* ITO Launch Price Box */}
            <div className="bg-[#1C1428] py-5 px-4 rounded-lg">
              <div className="flex flex-col sm:flex-row justify-between items-center gap-2">
                <h3 className="text-xl sm:text-2xl font-bold bg-gradient-to-r from-[#ECEFF0] to-[#E5C0FF] bg-clip-text text-transparent">
                  ITO Launch Price
                </h3>
                <h3 className="text-xl sm:text-2xl font-bold bg-gradient-to-r from-[#ECEFF0] to-[#E5C0FF] bg-clip-text text-transparent">
                  $0.005 per coin
                </h3>
              </div>
            </div>

            <p className="text-sm sm:text-base text-gray-300">
              Once we hit 2 billion coins sold, presale closes until our next round launches.
            </p>

            {/* Platforms Section */}
            <div className="space-y-3">
              <h4 className="text-lg sm:text-xl font-bold text-white">
                Where You'll Find Us After Launch:
              </h4>
              <div className="space-y-1 text-sm sm:text-base text-gray-300">
                <div>1. ROBINHOOD</div>
                <div>2. COINBASE</div>
                <div>3. CRYPTO.COM</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Ito;
